module.exports = __webpack_public_path__ + "img/avatar-capacitor.0e77e7e2.jpg";